<template>
  <div class="weui-cell__bd"
       :value="value">
    <div class="weui-uploader">
      <div class="weui-uploader__hd">
        <p class="weui-uploader__title"
           v-html="value.action_tips|| '' " />
      </div>
      <div class="weui-uploader__bd">
        <ul v-for="(imgurl,index) in value.default"
            id="uploaderFiles"
            :key="index"
            class="weui-uploader__files uploadfiles">
          <li class="weui-uploader__file">
            <div class="img"
                 @click="showPhoto(imgurl)"
                 style="width:auto;">
              <img :src="imgurl"
                   style="height:100px;">
            </div>

            <!-- <div class="pic-del"
                 @click="deletePhoto(index, value)">
              删除
            </div> -->
          </li>
        </ul>

      </div>
    </div>
    <div v-show="hide">
      <div class="weui-mask" />
      <div class="weui-dialog">
        <div class="weui-dialog__hd">
          <strong class="weui-dialog__title">提示</strong>
        </div>
        <div class="weui-dialog__bd">
          <ol id="ol-complete"
              class="complete-ol"
              style="list-style-type: decimal"
              v-html="hidemsg" />
        </div>
        <div class="weui-dialog__ft">
          <a href="javascript:;"
             class="weui-dialog__btn weui-dialog__btn_primary"
             @click.prevent="hide=false">确定</a>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { removeByValue } from '../../datas/js/common.js'
export default {
  name: 'WechatUploadimg',
  props: ['value'],
  data () {
    return {
      isdel: false,
      hide: false,
      hidemsg: '',
      popupGzWts: false
    }
  },
  mounted () {
    const _this = this
    this.$nextTick(() => {
      if (document.getElementById('gzWts')) {
        document.getElementById('gzWts').onclick = e => {
          _this.popupGzWts = true
        }
      }
    })
  },

  methods: {
    showPhoto (src) {
      // var gallery = weui.gallery(src, { // eslint-disable-line
      //   className: 'custom-classname'
      // })
      this.$alert(`<img  src="${src}"
                   style="max-width:90vw;max-height:80vh">`, '图片', {
        dangerouslyUseHTMLString: true
      });
    },
    deletePhoto (index, node) {
      removeByValue(node.default, node.default[index])
      console.log(node.default)
      this.$emit('update')
    },
    updateFile (node, event) {
      $('#' + node.id).trigger('click')  // eslint-disable-line
      if (!Array.isArray(node.default)) {
        node.default = []
      }
    },
    addPhoto (node, fileInput) {
      var uploadUrl = '/arlicle/admin/api_file_upload/'
      let file
      if (fileInput.files.length) {
        for (var i = 0; i < fileInput.files.length; i++) {
          file = fileInput.files[i]
          let fd
          fd = new window.FormData()
          fd.append('file', file)

          fetch(uploadUrl, { method: 'post', body: fd }).then(function (response) {
            if (response.status !== 200) {
              this.showMsg('上传失败，请重新上传')
            }
            console.log(response)
            return response.json()
          }).then(function (data) {
            console.log(data)
            if (data.status === 'success') {
              node.default.push(data.urls[0].url)
            } else {
              this.showMsg('上传失败，请重新上传')
            }
          })
        }
      }
    },
    showMsg (hidemsg) {
      this.hide = true
      this.hidemsg = hidemsg
    },
    Inputchange (node) {
      var falg = 0
      var fileInput = document.getElementById(node.id)
      if (!fileInput.files.length) {
        return ''
      }
      if (fileInput.files.length === 1) {
        if (fileInput.files[0].type.indexOf('image') < 0) {
          falg = 1
          this.showMsg('请选择图片格式文件！')
          return ''
        }
        if (fileInput.files[0].size / 1024 / 1024 >= 20) {
          this.showMsg('请选择小于20M的图片!')
          falg = 1
        }
      } else {
        this.showMsg('请选择一张图片上传')
      }
      if (!falg) {
        this.addPhoto(node, fileInput)
      }
    }
  }
}
</script>
<style scope >
.weui-gallery__opr {
  display: none !important;
}
.uploadfiles {
  overflow: hidden;
}
.uploadfiles .weui-uploader__file {
  position: relative;
}
.uploadfiles .weui-uploader__file .btn-delete {
  position: absolute;
  display: flex;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);
}
.uploadfiles .weui-uploader__file {
  float: left;
  height: auto;
}
.uploadfiles .weui-uploader__file .img {
  width: 100%;
  height: 100px;
  background-size: cover;
}
.weui-uploader__title {
  color: #fff;
  font-size: 18px;
  margin-bottom: 20px;
}

.pic-del {
  margin: 0 auto;
  width: 100%;
  text-align: center;
  margin-top: 10px;
  margin-bottom: 5px;
}
</style>
